'use strict';

var URL_REG = /(\w+):\/\/\/?([^\:|\/]+)(\:\d*)?(.*\/)([^#|\?|\n]+)?(\?[^#]*)?(#.*)?/i;
var URL_MAP = ['url', 'protocol', 'hostname', 'port', 'path', 'name', 'query', 'hash'];
var isFunction = function isFunction(fn) {
    return typeof fn === 'function';
};
var isNull = function isNull(obj) {
    return obj === void 0 || obj === null;
};
var encodeFormat = function encodeFormat(data, isEncode) {
    data = (data === null ? '' : data).toString().trim();
    return isEncode ? encodeURIComponent(data) : data;
};
var decodeFormat = function decodeFormat(data, isDecode) {
    return isNull(data) ? data : isDecode ? decodeURIComponent(data) : data;
};
var jsonToQuery = function jsonToQuery(json, isEncode) {
    var qs = [],
        k = void 0,
        i = void 0,
        len = void 0;
    for (k in json) {
        if (isNull(json[k])) {
            qs = qs.concat(k);
        } else if (Array.isArray(json[k])) {
            for (i = 0, len = json[k].length; i < len; i++) {
                if (!isFunction(json[k][i])) {
                    qs.push(k + "=" + encodeFormat(json[k][i], isEncode));
                }
            }
        } else if (!isFunction(json[k]) && !isNull(json[k])) {
            qs.push(k + "=" + encodeFormat(json[k], isEncode));
        }
    }
    return qs.join('&');
};
var queryToJson = function queryToJson(qs, isDecode) {
    var qList = qs.trim().split("&"),
        json = {},
        i = 0,
        len = qList.length;
    for (; i < len; i++) {
        if (qList[i]) {
            var hash = qList[i].split("="),
                key = hash[0],
                value = hash[1];
            if (!(key in json)) {
                json[key] = decodeFormat(value, isDecode);
            } else {
                json[key] = [].concat(json[key], decodeFormat(value, isDecode));
            }
        }
    }
    return json;
};

module.exports = function (str, decode) {
    var scope = {},
        m = URL_REG.exec(str) || [];
    URL_MAP.forEach(function (key, index) {
        return scope[key] = m[index];
    });
    scope.query = scope.query ? queryToJson(scope.query.substring(1), decode) : {};
    scope.hash = scope.hash ? queryToJson(scope.hash.substring(1), decode) : {};

    scope.getQuery = function (key) {
        return scope.query[key];
    };

    scope.getHash = function (key) {
        return scope.hash[key];
    };

    scope.setQuery = function (key, value) {
        if (value === UNDEFINED) {
            scope.query[key] = NULL;
        } else {
            scope.query[key] = value;
        }
        return scope;
    };

    scope.setHash = function (key, value) {
        if (value === UNDEFINED) {
            scope.hash[key] = NULL;
        } else {
            scope.hash[key] = value;
        }
        return scope;
    };

    scope.toUrl = function (encode) {
        var url = scope.protocol + '://',
            query = jsonToQuery(scope.query, encode),
            hash = jsonToQuery(scope.hash, encode);
        if (scope.protocol && scope.protocol.toLowerCase() === 'file') {
            url += '/';
        }
        return url + scope.hostname + (scope.port || '') + scope.path + (scope.name || '') + (query ? '?' + query : '') + (hash ? '#' + hash : '');
    };

    return scope;
};


//////////////////
// WEBPACK FOOTER
// ../plugins/qunar/util/parseUrl.js
// module id = 37
// module chunks = 1 3 4